import Forward from "@/views/Forward.vue";

export default (rootPath) => {
  return [
    {
      path: "",
      component: Forward,
      redirect: `${rootPath}/edit/federal`,
      hidden: true,
      children: [
        {
          path: "list",
          component: () => import("@/views/table/ChannelsTable.vue"),
          meta: { title: "Список каналов", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "create",
          component: () => import("@/views/forms/ChannelsForm.vue"),
          meta: { title: "Создать канал", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "edit/:id",
          component: () => import("@/views/forms/ChannelsForm.vue"),
          meta: { title: "Редактировать канал", activeMenuParent: true },
          hidden: true,
        },
      ],
    },
  ];
};
